export default class PutDocumentProgrammationQuery {
    is_canceled: boolean;
    date_validity_start?: string;
    date_validity_end?: string;

    constructor(data: {
        is_canceled: boolean;
        date_validity_start?: string;
        date_validity_end?: string;
    }) {
        this.is_canceled = data.is_canceled;
        this.date_validity_start = data.date_validity_start;
        this.date_validity_end = data.date_validity_end;
    }
} 